import { Position } from '../types';

const getPointsRelativeToPosition = (
  points: Position[],
  position: Position
): Position[] =>
  points.map(({ x, y }) => ({ x: x - position.x, y: y - position.y }));

export default getPointsRelativeToPosition;
